import React from 'react';
import styled from 'styled-components';

interface Props {
  leftColumnChildren: JSX.Element,
  rightColumnChildren: JSX.Element,
}

const Container = styled.div`
  display: flex;
  height: 100%;
  flex: 0 0 100%;
  flex-direction: row;

  & .left-column {
    flex: 1 0 30%;
  }

  & .right-column {
    flex: 1 0 64%;
    margin: 0 3%;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const TwoColumnsLayout = ({ leftColumnChildren, rightColumnChildren }: Props) => {
  return (
    <Container>
      <div className='left-column'>
        { leftColumnChildren }
      </div>
      <div className='right-column'>
        { rightColumnChildren }
      </div>
    </Container>
  )
};

export default TwoColumnsLayout;
